module.exports = __webpack_public_path__ + "img/times-circle.b3db579a.svg";